<template>
  <el-row>
    手术管理
    {{entity}}
  </el-row>
</template>
<script>
import api from "../api"
export default {
  props: {
    entity: Object
  }
}
</script>